<template>
  <div class="home-view main-wrapper">
    <div
      id="tournav"
      class="flex flex-row justify-center w-full items-center nav bg-white z-10 shadow-lg flex-no-wrap"
    >
      <a
        :id="`${personaPrefix}SagePeopleLogo`"
        :href="sagePeoplePage"
        class="w-6/12 md:w-10/12 ml-1 md:ml-6 main-logo-tour"
      >
        <img alt width="140" src="../assets/img/sage-logo-black.png" />
      </a>
    </div>

    <div class="transition-container">
      <div class="flex flex-row justify-start flex-wrap">
        <transition
          name="home"
          enter-active-class="animated slideInLeft"
          appear
        >
          <div
            class="left-persona-bar w-full md:w-2/6 flex flex-col items-center"
          >
            <div class="persona-container no-hover flex flex-col items-start">
              <img
                alt=""
                :src="personasArray[selectedPersonaIndex].image"
                width="100%"
              />
              <p class="text-white font-bold pt-4 px-12">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}Name`
                  )
                }}
              </p>
              <p class="text-white pb-4 px-12">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}Type`
                  )
                }}
              </p>
            </div>
            <div class="flex flex-col md:hidden p-6 w-full">
              <h2 class="pb-6 text-white">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}Type`
                  )
                }}
              </h2>
              <p class="heading pb-6 text-white">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}BoldBody`
                  )
                }}
              </p>
              <p class="pb-6 whitespace-pre-line text-white">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}Body`
                  )
                }}
              </p>
              <button
                @click="startTour(), submitEventToData($event)"
                id="OB_Overview_BeginTour"
                class="tmp-btn"
              >
                {{ $t("homePage.ctaBegin") }}
              </button>
            </div>
            <div class="flex flex-row justify-center p-6">
              <a
                v-for="(persona, index) in unselectedPersonas"
                :key="index"
                @click="setSelectedPersonaIndex(persona.index)"
                class="persona-container no-hover small-persona mr-2 my-4"
              >
                <img alt="" :src="persona.image" width="200" />
                <p class="text-white text-xs font-bold pt-2 px-4 leading-tight">
                  {{ $t(`homePage.${persona.i18nKey}Name`) }}
                </p>
                <p class="text-white text-xs pb-2 px-4">
                  {{ $t(`homePage.${persona.i18nKey}Type`) }}
                </p>
              </a>
            </div>
          </div>
        </transition>

        <transition
          name="home"
          enter-active-class="animated slideInRight fast"
          appear
        >
          <div
            class="right-persona-bar w-2/6 p-4 md:p-12 hidden md:flex items-center justify-center"
          >
            <div>
              <h2 class="pb-6">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}Title`
                  )
                }}
              </h2>
              <p class="heading pb-6">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}BoldBody`
                  )
                }}
              </p>
              <p class="pb-6 whitespace-pre-line">
                {{
                  $t(
                    `homePage.${personasArray[selectedPersonaIndex].i18nKey}Body`
                  )
                }}
              </p>
              <button
                @click="startTour(), submitEventToData($event)"
                id="OB_Overview_BeginTour"
                class="tmp-btn"
              >
                {{ $t("homePage.ctaBegin") }}
              </button>
            </div>
          </div>
        </transition>

        <transition
          name="home"
          enter-active-class="animated slideInRight fast"
          appear
        >
          <div
            class="flex w-2/6 justify-center px-12 pt-24 relative"
            :key="personaVideo"
          >
            <img
              alt=""
              style="
                width: 35vw;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
              src="../assets/img/laptop-slim.png"
            />
            <video
              style="width: 24vw"
              muted
              playsinline
              autoplay
              class="absolute video-preview"
            >
              <source :src="personaVideo" type="video/mp4" />
            </video>
          </div>
        </transition>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="mobileNotice"
        class="welcome-modal-wrapper flex md:hidden justify-center items-start"
      >
        <transition name="zoom">
          <div class="welcome-modal-inner-wrapper mt-6">
            <p class="heading pb-4 pt-6 px-6">Viewing on a mobile device?</p>
            <p class="px-6 pb-4">
              This tour has been set up for desktop viewing – we’d recommend
              switching over for the full experience.
            </p>
            <div class="flex flex-row justify-end full-w">
              <button
                @click="(mobileNotice = false), submitEventToData($event)"
                class="tmp-btn green text-white self-end text-sm"
                id="Tour_Mobile_Notifications_Next"
              >
                Dismiss
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import personasArray from "../config/home/index";
export default {
  name: "Home",
  data: () => {
    return {
      mobileNotice: true,
      personasArray,
    };
  },
  computed: {
    selectedPersonaIndex() {
      return this.$store.state.selectedPersonaIndex;
    },
    personaPrefix() {
      return this.$store.state.personaPrefix;
    },
    sagePeoplePage() {
      return this.$store.state.sagePeoplePage;
    },
    unselectedPersonas() {
      return this.personasArray.filter(
        (persona, index) => index !== this.selectedPersonaIndex
      );
    },
    personaVideo() {
      return `../assets/videos/${
        this.personasArray[this.selectedPersonaIndex].videoPrefix
      }Preview.mp4`;
    },
  },
  methods: {
    setSelectedPersonaIndex(index) {
      this.$store.state.selectedPersonaIndex = index;
    },
    submitEventToData(event) {
      // eslint-disable-next-line
      utag.link({
        event_category: "Interactive Tool",
        event_action: "Overview",
        event_label: event.target.id,
      });
    },
    startTour() {
      this.$router.history.push("p");
    },
  },
  mounted() {
    console.log(this.$store.state.primary);
  },
};
</script>

<style lang="scss" scoped>
.main-logo-tour img {
  max-height: 50px;
  width: auto;
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  height: 60px;
  border-bottom: 1px solid #f1f1f1;
}

.welcome-modal-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 400;
  background: #000000b0;

  & .welcome-modal-inner-wrapper {
    width: 100%;
    max-width: 400px;
    box-shadow: 0 10px 40px 0 rgba(0, 20, 29, 0.04),
      0 50px 80px 0 rgba(0, 20, 29, 0.1);
    background: #ffffff;
    position: absolute;
  }
}

.video-preview {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.home-blue {
  background: #ffffff;
}

.tmp-btn {
  background-color: #0077c8;
  color: white;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  padding: 11.5px 30px;
  border-radius: 0;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;

  &:focus {
    outline: 5px solid #ffb500;
  }

  &.green {
    background: #00a376;
  }

  &.ghost {
    background-color: transparent;
    border: 1px solid white;

    &:hover {
      background-color: white;
      border: 1px solid white;
      color: #19485c;
    }
  }
}

.left-persona-bar {
  max-width: 400px;
  min-width: 250px;
  background: #000000;
  // height: calc(100vh - 60px);
  height: calc(100vh - 60px);
  box-sizing: border-box;
  margin-top: 60px;
}

.right-persona-bar {
  // height: calc(100vh - 60px);
  height: calc(100vh - 60px);
  box-sizing: border-box;
  overflow-y: auto;
  margin-top: 60px;
}

.main-wrapper {
  position: relative;
  // margin-top: 60px;
  width: 100%;
}

.transition-container {
  top: 0;
  left: 0;
  width: 100%;
}

.persona-container {
  background: #2C3333;
  transition: all 0.2s linear;
  cursor: default;
  opacity: 1;
  z-index: 3;
  position: relative;

  &.home-screen {
    &::after {
      content: "";
      position: absolute;
      background: #2C3333;
      z-index: -1;
      animation: outlinePulse 2s infinite linear;
    }
  }

  // &:hover {
  //   opacity: 0.8;
  //   transform: translateY(-5%);
  //   transition: all 0.2s linear;
  // }
  &.no-hover {
    transform: none;
    opacity: 1;
  }

  &.small-persona {
    width: 33%;

    & img {
      filter: grayscale(1);
      transition: all 0.2s linear;

      &:hover {
        filter: none;
        transform: translateY(-5%);
        transition: all 0.2s linear;
      }
    }
  }
}

.container-900 {
  max-width: 900px;
}

.home-banner {
  background: url("../assets/img/Hero-Banner@2x.jpg");
  background-size: cover;
}

.inner-banner {
  background: #0077c8;
  max-width: 700px;
  box-sizing: border-box;
}

@keyframes outlinePulse {
  0% {
    top: 50%;
    left: 50%;
    height: 100%;
    width: 100%;
    transform: translate(-50%, -50%);
    opacity: 0.2;
  }

  100% {
    top: 50%;
    left: 50%;
    height: 110%;
    width: 110%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }
}

@-webkit-keyframes outlinePulse {
  0% {
    top: 50%;
    left: 50%;
    height: 100%;
    width: 100%;
    transform: translate(-50%, -50%);
    opacity: 0.2;
  }

  100% {
    top: 50%;
    left: 50%;
    height: 110%;
    width: 110%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }
}

@media screen and (max-width: 834px) {
  .left-persona-bar,
  .right-persona-bar {
    height: 100%;
    max-width: none;
  }
}
</style>
